var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 6.75H2.88889V8.25H4.33333V6.75ZM7.22222 6.75H5.77778V8.25H7.22222V6.75ZM10.1111 6.75H8.66667V8.25H10.1111V6.75ZM11.5556 1.5H10.8333V0H9.38889V1.5H3.61111V0H2.16667V1.5H1.44444C0.642778 1.5 0.00722222 2.175 0.00722222 3L0 13.5C0 14.325 0.642778 15 1.44444 15H11.5556C12.35 15 13 14.325 13 13.5V3C13 2.175 12.35 1.5 11.5556 1.5ZM11.5556 13.5H1.44444V5.25H11.5556V13.5Z",
    fill: "#848585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGrey);
export default __webpack_public_path__ + "static/media/calendar-grey.c2dd1b28bd53efc6c2c962b0ef89a06e.svg";
export { ForwardRef as ReactComponent };